import React from 'react';
import PropTypes from 'prop-types'

import { translate } from '../../commons/localize';

import ChildsForm from './ChildsForm';

import './ChildsSelector.css';

const getDataToPrint = (numberOfPaxes, agesList) => {
  const items = agesList.length;

  if (!items) return numberOfPaxes;

  let agesDataLabel = '';
  agesList.forEach((age, index) => {
    const isLastItem = (index === (items - 1));
    const separator = (isLastItem) ? ` ${translate('textSeparator')} ` : ', ';
    const yearLabel = (age === 1) ? translate('anno') : translate('annos');

    if (index === 0) agesDataLabel = age;
    else agesDataLabel = `${agesDataLabel}${separator}${age}`;

    if (isLastItem) agesDataLabel = `${agesDataLabel} ${yearLabel}`;
  });

  return `${numberOfPaxes}<span>(${agesDataLabel})</span>`;
}

class ChildsSelector extends React.Component {
  static propTypes = {
    dataTestLabel: PropTypes.string,
    childsValue: PropTypes.number,
    childsAges: PropTypes.arrayOf(PropTypes.number),
    maxOccupancy: PropTypes.number,
    minAge: PropTypes.number,
    maxAge: PropTypes.number,
    readOnly: PropTypes.bool,
    isBlocked: PropTypes.bool,
    handleSelectOption: PropTypes.func
  }

  static defaultProps = {
    dataTestLabel: '',
    childsValue: 0,
    childsAges: [],
    maxOccupancy: 0,
    minAge: 0,
    maxAge: 1,
    readOnly: false,
    isBlocked: false,
    handleSelectOption: () => {}
  }

  constructor(props){
    super(props)
    this.state = {
      selectedValue: getDataToPrint(this.props.childsValue, this.props.childsAges),
      showForm: false,
      changedByForm: false
    }
  }

  componentDidUpdate(prevProps) {
    const { maxOccupancy, childsValue, childsAges  } = this.props;
    const { changedByForm } = this.state;

    if (prevProps.maxOccupancy === maxOccupancy) {
      const { childsAges: oldChildsAges, childsValue: oldChildsValue } = prevProps;

      if (childsAges === oldChildsAges && childsValue === oldChildsValue) return;
        
      if (!changedByForm) this.setStateOnly(childsValue, childsAges);

      if (changedByForm) this.cleanState();
      
      return;
    };

    this.setStateOnly(childsValue, childsAges);
  }

  cleanState = () => {
    this.setState({
      changedByForm: false
    });
  }

  setStateOnly = (childsValue, childsAges) => {
    this.setState({
      selectedValue: getDataToPrint(childsValue, childsAges),
      showForm: false,
      changedByForm: false
    });
  }

  openChildsForm = () => {
    const { readOnly } = this.props;
    const { showForm } = this.state;

    if (readOnly) return;

    if (showForm === true) return;

    this.setState({
      showForm: true,
      changedByForm: false
    });
  }

  closeChildsForm = () => {
    this.setState({
      showForm: false
    });
  }

  getAgesRangeList = () => {
    const { maxAge } = this.props;

    // Se cambia el valor del minAge para albercar los bebes dentro de la cat. niños
    const minAge = 1;

    return [...Array((maxAge - minAge) + 1).keys()].map((i) => {
      const customValue = (i + minAge);
      // const customLabel = `${customValue} ${(customValue === 1) ? translate('anno') : translate('annos')}`;
      const customLabel = `${customValue}`;
      
      return { label: customLabel, value: customValue }
    });
  }

  setSelectedValue = (wishedPaxes, agesList, updateData) => {
    this.setState({
      selectedValue: getDataToPrint(wishedPaxes, agesList),
      changedByForm: true
    }, () => {
      if (!updateData) return;

      setTimeout(() => {
        this.closeChildsForm();
      }, 150);

      if (updateData) this.props.handleSelectOption(wishedPaxes, agesList);
    });
  }

  getContainerClasses = (baseClass) => {
    const { readOnly, isBlocked } = this.props;
    const { showForm } = this.state;

    let finalClass = baseClass;

    if (readOnly) return `${finalClass} read-only`;

    if (showForm) finalClass = `${finalClass} edition-mode`;

    if (isBlocked) finalClass = `${finalClass} dirty-prevent`;
    
    return finalClass;
  }

  render() {
    const { selectedValue, showForm } = this.state;
    
    const {
      readOnly,
      childsValue,
      childsAges,
      maxOccupancy
    } = this.props;

    const iconCustomClass = `fas ${(showForm) ? 'fa-chevron-up' : 'fa-chevron-down'}`;

    return (
      <div className={this.getContainerClasses('childs-selector__container')}>
        <label className="main-title">
          {translate('ninos')}
        </label>
        <div className="component-container" data-test-id="selector-ninos" onClick={this.openChildsForm}>
          <div className="value__container">
            <div className="selected-value" dangerouslySetInnerHTML={{__html: selectedValue}} />
            <i className={iconCustomClass} />
          </div>
        </div>
        {(!readOnly) &&
          <ChildsForm
            defaultPaxes={childsValue}
            defaultAges={childsAges}
            isOpen={showForm}
            maxPaxes={maxOccupancy}
            agesOptions={this.getAgesRangeList()}
            handleFormData={this.setSelectedValue}
            closeForm={this.closeChildsForm}
          />
        }
      </div>
    );
  }
};

export default ChildsSelector;
